import { VideoInTextTeaserTheme } from '@/components/VideoInTextTeaser/theme';
import { VideoTeaser as StandaloneVideoTeaser } from '@/components/VideoTeaser';
import { GenericSlot } from 'base/components/GenericSlot';

export const VideoInTextTeaser = GenericSlot({ as: StandaloneVideoTeaser, theme: VideoInTextTeaserTheme });
